export default "__VITE_ASSET__49957f53__"